/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Step_CompanyInputs */

const cs_auth_signup_step_company = /** @type {(inputs: Auth_Signup_Step_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma`)
};

const en_auth_signup_step_company = /** @type {(inputs: Auth_Signup_Step_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Auth_Signup_Step_CompanyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_step_company = /** @type {((inputs?: Auth_Signup_Step_CompanyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Step_CompanyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_step_company(inputs)
	return cs_auth_signup_step_company(inputs)
});